import React from 'react';
import {LeftArrowThin} from "../shared/icons";
import styles from './LeftArrow.scss'

interface ILeftArrow {
    onClick: () => void
}
export const LeftArrow = ({onClick}: ILeftArrow) => {
    return (
        <div className={styles.leftArrow} onClick={onClick}>
            <LeftArrowThin/>
        </div>
    );
};

